module.exports = __webpack_public_path__ + "static/media/logo.bf580c58.svg";